import Repository from '@/libs/axios'
import OperationRepository from '@/libs/customAxios/operationAxios'

const flagResource = '/merchant/order/flag'
const orderResource = '/merchant/order?sort=-created_at'

// const defaultPagination = 10

export default {
  createFlag(payload) {
    return Repository.post(`${flagResource}`, payload)
  },
  getOrders() {
    return OperationRepository.get(`${orderResource}`)
  },
  fetchFlagDetails(id) {
    return Repository.get(`/merchant/flag/${id}`)
  },
}
